window.$ = window.jQuery = require("jquery");
require("jquery-ui");
require("jquery-ui/ui/widgets/datepicker.js");
require("jquery-ui/ui/i18n/datepicker-ja.js");
require("jquery-ui/ui/i18n/datepicker-zh-CN.js");
